class ThumbnailRenderer {
  constructor(maximumSize = 100) {
    this.maximumSize = maximumSize;
  }

  async renderThumbnail(file) {
    if (this.isImage(file.name))
      return await this.generateImageThumbnail(file);
    else
      return await this.generatePlaceholderThumbnail(file);
  }

  isImage(fileName) {
    return /\.(png|jpeg|jpg|gif|webp|bmp)$/i.test(fileName);
  }

  async generateImageThumbnail(file) {
    const fileBlob = new Blob([file.contents]);
    const imageBitmap = await createImageBitmap(fileBlob);

    const scaleFactor = Math.min(
      this.maximumSize / imageBitmap.width,
      this.maximumSize / imageBitmap.height
    );
    const thumbnailWidth = imageBitmap.width * scaleFactor;
    const thumbnailHeight = imageBitmap.height * scaleFactor;

    const offscreenCanvas = new OffscreenCanvas(thumbnailWidth, thumbnailHeight);
    const canvasContext = offscreenCanvas.getContext("2d");

    canvasContext.drawImage(imageBitmap, 0, 0, thumbnailWidth, thumbnailHeight);
    return await offscreenCanvas.convertToBlob({ type: "image/png" });
  }

  async generatePlaceholderThumbnail(file) {
    const offscreenCanvas = new OffscreenCanvas(this.maximumSize, this.maximumSize);
    const canvasContext = offscreenCanvas.getContext("2d");

    canvasContext.fillStyle = "#e0e0e0";
    canvasContext.fillRect(0, 0, offscreenCanvas.width, offscreenCanvas.height);

    const fileExtension = file.name.split(".").pop().toUpperCase() || "FILE";

    canvasContext.fillStyle = "#404040";
    canvasContext.font = "bold 20px Arial";
    canvasContext.textAlign = "center";
    canvasContext.textBaseline = "middle";
    canvasContext.fillText(fileExtension, offscreenCanvas.width / 2, offscreenCanvas.height / 2);

    return await offscreenCanvas.convertToBlob({ type: "image/png" });
  }
}
